// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getDayOfYear as fn } from "../getDayOfYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getDayOfYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getDayOfYearWithOptions;
